<template>
  <!-- The signed-in navy bar on the pages without their own (Pricing, the legal pages, verify email, 404 …), styled
       like the editor's and My videos' bars: the G mark at the same spot, then the way back to My videos, and the
       account on the right. Visitors get the glass MarketingTopBar on every page they can reach. -->
  <nav
    aria-label="Main"
    class="h-[62px] shrink-0 flex items-center justify-between gap-3 pl-4 pr-4 sm:pr-[26px] bg-dark-nav border-b border-white/10 shadow-[inset_0_1px_0_rgb(255_255_255/0.08),0_2px_12px_rgb(30_41_59/0.12)]"
  >
    <div class="flex min-w-0 items-center gap-2">
      <router-link :to="{ name: 'library' }" class="shrink-0" title="Gettourly" tabindex="-1" aria-hidden="true">
        <img src="/logo-mark-clear.svg" alt="" class="size-[50px]" />
      </router-link>
      <router-link
        :to="{ name: 'library' }"
        class="inline-flex h-[34px] items-center gap-1 rounded-lg pl-1.5 pr-3 text-sm font-medium text-white/75 transition-colors hover:bg-white/10 hover:text-white"
      >
        <ChevronLeft :size="18" aria-hidden="true" />
        My videos
      </router-link>
    </div>

    <AccountControls />
  </nav>
</template>

<script setup lang="ts">
import { ChevronLeft } from 'lucide-vue-next'
import AccountControls from '@/components/AccountControls.vue'
</script>
